<form [formGroup]="measuringEquipmentForm" [ngClass]="disabled ? 'disable-input' : ''">
    <div class="row row-cols-1">
        <div class="column-input col-12" [ngClass]="row.columns.length > 3 ? 'col-sm-3' : 'col-sm-4'">
            <pace-forms-input-text
                [id]="row.columns[0].columnId"
                [inputPlaceholder]="row.columns[0].columnName"
                [formControl]="descriptionControl"
            >
            </pace-forms-input-text>
        </div>
        <div class="column-input col-12" [ngClass]="row.columns.length > 3 ? 'col-sm-3' : 'col-sm-4'">
            <pace-forms-input-text
                [id]="row.columns[1].columnId"
                [inputPlaceholder]="row.columns[1].columnName"
                [formControl]="equipmentIdControl"
                showScanner="true"
            >
            </pace-forms-input-text>
        </div>
        <div class="column-input col-12 mt-3 pt-1" [ngClass]="row.columns.length > 3 ? 'col-sm-3' : 'col-sm-4'">
            <span class="d-sm-none col-form-label">{{ row.columns[2].columnName }}</span>
            <div class="input-group">
                <input
                    class="form-control mb-3"
                    type="date"
                    placeholder="{{ row.columns[2].columnName }}"
                    [ngClass]="{
                        'is-invalid': calibratedControl.hasError('invalidDate'),
                    }"
                    [formControl]="calibratedControl"
                />
            </div>
        </div>
        @if (row.columns.length > 3) {
            <div class="column-input col-12 mt-3 pt-1 col-sm-3">
                <span class="d-sm-none col-form-label">{{ row.columns[3]?.columnName }}</span>
                <div class="input-group">
                    <input
                        class="form-control mb-3"
                        type="date"
                        placeholder="{{ row.columns[3]?.columnName }}"
                        [formControl]="dateUsedControl"
                    />
                </div>
            </div>
        }
    </div>
</form>
